import styled, { css } from "styled-components";

const Container = styled.div`
  padding-bottom: 22px;
  display: flex;
  flex-direction: column;
`;

interface BodyProps {
  selfMessage: boolean;
}

const Body = styled.div<BodyProps>`
  width: 80%;

  ${(props) => (props.selfMessage
    ? css`
          align-self: flex-end;
          border-right: 3px solid #a3a3a3;
          padding-right: 10px;
        `
    : css`
          border-left: 3px solid #284796;
          padding-left: 10px;
        `)}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  font-size: 10px;
  padding-bottom: 4px;
`;

const UserName = styled.div`
  font-weight: bold;
`;

const UserRole = styled.div`
  color: #707070;

  &::before {
    content: "·";
    margin-right: 5px;
    margin-left: 5px;
  }
`;

const Content = styled.div`
  font-size: 14px;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Date = styled.div`
  font-size: 12px;
  color: #707070;
  align-self: flex-end;
`;

export { Container, Body, Header, UserName, UserRole, Content, Footer, Date };
